import Colors from '../../../../../styles/colors';

const styles = () => ({
    '@keyframes loading': {
        from: {
            width: '0%',
        },
        to: {
            width: '75%',
        },
    },
    '@keyframes loaded': {
        from: {
            width: '75%',
        },
        to: {
            width: '100%',
        },
    },
    meter: {
        height: 3,
        marginTop: 5,
        background: Colors.lightGrey,
        '& span': {
            display: 'block',
            height: '100%',
            backgroundColor: Colors.mediumAquamarine,
        },
    },
    meterLoading: {
        animationName: '$loading',
        animationTimingFunction: 'easeIn',
        animationDuration: '3s',
        animationFillMode: 'forwards', // hold finishing state
    },
    meterLoaded: {
        width: '75%',
        animationName: '$loaded',
        animationTimingFunction: 'easeOut',
        animationDuration: '.6s',
        animationFillMode: 'forwards',
    },
    deletedBtnIcon: {
        color: Colors.raspberryRose,
        fill: Colors.raspberryRose,
    },
});

export default styles;
